package home

import antd.button.button
import antd.form.form
import antd.form.formItem
import antd.message.message
import com.jingfangpai.common.data.model.CascadedOption
import com.jingfangpai.content.model.ContentQuery
import kotlinext.js.js
import react.*
import react.dom.*
import kotlinx.html.unsafe
import smartTcm.components.DiagnosisConversationComponent
import user.components.LoginModal

external interface HomeProps : RProps {
    var userId:String?
}

val Home = functionalComponent<HomeProps> { props ->

    val ctx = useContext(HomePageContext)
    val (currentUserId,setCurrentUserId) = useState(props.userId)
    val (symptomOptions,setSignSymptomOptions) = useState(arrayOf<CascadedOption<String>>())
    val (contentQuery,setContentQuery) = useState(ContentQuery().apply {
        includeComments = true
    })
    val (showEnquiryForm,setShowEnquiryForm) = useState(false)
    val (showUserLoginForm,setShowUserLoginForm) = useState(false)

    useEffectOnce {
        ctx.getOptions({ resp->
            if(resp.ok()) {
                resp.data?.let{
                  setSignSymptomOptions(it)
                }
            }else{
                message.error("获取体征症状出错：${resp.message}")
            }
        },{
            message.error("获取体征症状出错：${it.message}")
        })
    }



    div("home") {
        attrs{
            jsStyle = js{
                textAlign = "center"
                maxWidth = "980px"
                margin = "0 auto"
            }
        }

        div("keyword-input"){

            div{
                attrs{
                    jsStyle = js{
                        marginTop = "150px"
                        position = "relative"
                    }
                }
                div("cartoon"){
                    div("shirt-neck shirt-neck-back b"){}
                    div("hair hair-back-bottom r b"){}
                    div("hair hair-back hair-back-back r b"){}
                    div("shirt b r"){}
                    div("shirt-line-2 b"){}
                    div("head r"){}
                    div("hair hair-back r b"){}
                    div("ear r ha hb"){}
                    div("nose r"){}
                    div("hair-container"){
                        div("hair hair-top r b ha"){}
                    }
                    div("eye r b"){}
                    div("mouth r ha"){}
                    div("shirt-line b"){}
                    div("shirt-neck b"){}
                    div("eyebrow r"){}
                    div("eyebrow r"){}
                    div("bubble b r hb"){
                        attrs.unsafe {
                            +"俺是经方健康助手，<br/>有问题找我吧"
                        }
                    }
                }

            }
        }
        div("home-logo"){
            div{
                attrs{
                    jsStyle = js{
                        width = "360px"
                        margin = "30px auto"
                    }

                }
                span{
                    attrs{
                        jsStyle = js{
                            fontSize = "40px"
                            fontWeight = "300px"
                            color = "#3791ff"
                        }
                    }
                    +"寻方问药"
                }
                div{
                    attrs{
                        jsStyle = js{
                            textAlign = "center"
                            margin= "16px 0"
                            fontWeight = "200"
                        }
                    }
                    +"以经方为核心理念，推动中医智能化与科学化，服务于社会大众的中医认知和问诊"
                }
            }
        }
        div("conversational-diagnosis-form"){
            attrs{
                jsStyle = js{
                    width = "540px"
                    margin = "30px auto"
                }
            }
            form{
                if(!showEnquiryForm && !showUserLoginForm) {
                    div {
                        attrs{
                            jsStyle = js{
                                marginTop = "20px"
                            }
                        }
                    }
                    formItem {
                        button {
                            attrs {
                                style = js {
                                    marginTop = "10px"
                                }
                                type = "primary"
                                onClick = {
                                    if(!props.userId.isNullOrBlank()) {
                                        setShowEnquiryForm(true)
                                    }else{
                                        setShowUserLoginForm(true)
                                    }
                                }
                            }
                            +"求医治"
                        }

                    }
                }

                if(showUserLoginForm){
                    div{
                        child(LoginModal){
                            attrs{
                                visible = showUserLoginForm
                                onLoginSuccess = {
                                    setCurrentUserId(it.id)
                                    setShowUserLoginForm(false)
                                    setShowEnquiryForm(true)
                                }
                                onClose = {setShowUserLoginForm(false)}
                            }
                        }
                    }
                }

                if(showEnquiryForm){
                    child(DiagnosisConversationComponent){
                        attrs{
                            signSymptomOptions = symptomOptions
                            getNextDiagnosisItem = ctx.getNextDiagnosisItem
                            onSubmit = ctx.saveFromRawData
                            patientId = currentUserId?:""
                        }
                    }
                }
            }
        }
        div("page-content"){
            attrs{
                jsStyle = js{
                    height = "500px"
                }
            }
        }

    }
}
